<template>
  <div class="doctor">
  	<Header msg="/doctor" />

  
  			<div class='backBox' @click='back' style='cursor:pointer;'>
	          <img :src="require('@/assets/icon-next2.png')" alt="">
	          <div>返回</div>
	    	</div>
			<div class='doctorPages'>
				<div class="dcLeft">
					<img :src="doctoritem.informal_url" >
				</div>
				<div class="dcRight">	
					<div class="dcname">{{doctoritem.member_name}}</div>
					<div class="dctitle">{{doctoritem.member_title}}</div>
					<div class="dcexp">{{doctoritem.member_exp}}</div>
					<!-- <div class="dcbrief">{{doctoritem.member_brief}}</div> -->
					<div class="dcintroduction"><span>{{dr1}}</span></div>

					<ul>
                      <li v-for='item in drlist'>{{item}}</li>
             
                    </ul>
				</div>

			</div>
    <Foot style='position: fixed;bottom:0'/>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'

export default {
  name: 'Doctor',
  components: {
      Header,
      Foot
  },
  data:()=>{
  	return{
  
  	}
  	
  },
   beforeCreate:function(){
   	if(!this.$route.params){
   		this.$router.go(-1)
   		return
   	}
 	let _doctoritem = this.$route.params._params
 	

 	if(!_doctoritem){
 		this.$router.go(-1)
 		return
 	}
 	this.doctoritem = _doctoritem
 	let _list =_doctoritem.member_introduction.split("-")
 	this.dr1 = _list[0]
 	_list.shift()
 	this.drlist = _list
 	
 },
  methods:{
	back(){
      this.$router.go(-1)
    },
  }
}
</script>
<style>
.doctor{
	width: 100%;
	height:100vh;
}
.doctorPages{
	/*padding-top: 128px;*/
	width: 72vw;
	max-width: 1040px;
	margin:0 auto 198px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

}
.dcLeft{
	width: 300px;
	margin-bottom: 2vw;
}
.dcLeft img{
	width: 300px;

	display: block;
}
.dcRight{
	width: 692px;
	text-align:left;
	margin-bottom: 2vw;
}
.dcname{
	height:30px;
	font-size:26px;
	font-family:OpenSans-Semibold;
	font-weight:600;
	color:rgba(20,20,20,1);
	line-height:36px;
	margin-bottom: 30px;
}
.dctitle{
	font-size:18px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(120,120,120,1);
	line-height:30px;
}
.dcexp{
	font-size:18px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(120,120,120,1);
	line-height:30px;
	margin-bottom: 30px;
}
.dcbrief{
	font-size:16px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(20,20,20,1);
	line-height:22px;
	margin-bottom: 30px;
}
.dcintroduction{
	font-size:16px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(20,20,20,1);
	line-height:30px;
	margin-bottom: 30px;
}
ul{
	margin: 0;
	padding: 20px;
}
ul li{
   display: block;
   font-size:16px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(20,20,20,1);
	line-height:30px;
  position: relative;
}
ul li:before{
  width: 7px;
  height:7px;
  background-color:#141414;
  border-radius: 5px;
  content: " ";
  display: block;
  position: absolute;
  top:13px;
  left: -18px
}
.backBox{
  width: 90vw;
  margin: 0 auto;
  height:22px;
  color: #787878;
  position: relative;
  display:flex;
  padding: 80px 0 90px 10px;
}
.backBox img{
	transform:rotate(180deg);
	-ms-transform:rotate(180deg); 	/* IE 9 */
	-moz-transform:rotate(180deg); 	/* Firefox */
	-webkit-transform:rotate(180deg); /* Safari 和 Chrome */
	-o-transform:rotate(180deg); 	/* Opera */
	width: 10px;
	height:14px;
	margin-right: 6px;
	position: relative;
	top:3px;
}
</style>